import { Reveal, SectionHead } from "@/components/Reveal";

const STEPS = [
  {
    number: "01",
    title: "THINK LIKE A PRODUCT",
    description:
      "Understand the people you serve, the problem you are solving, what matters most and what success looks like.",
    testid: "approach-step-1",
  },
  {
    number: "02",
    title: "BUILD THE SYSTEM",
    description:
      "Turn strategy into priorities, programs, processes, teams and operating rhythms that make execution easier.",
    testid: "approach-step-2",
  },
  {
    number: "03",
    title: "ADD INTELLIGENCE",
    description:
      "Use AI and automation where they create real leverage — reducing friction, improving workflows and helping teams focus on higher-value work.",
    testid: "approach-step-3",
  },
];

export default function Approach() {
  return (
    <section
      data-testid="approach-section"
      className="bg-ink py-20 text-paper sm:py-28 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHead
          chapter="02 — The KP Strategy Method"
          title="Think like a product. Build like a system."
          copy="We bring product thinking into how organizations make decisions, build capabilities, operate and improve — turning complexity into a clearer way forward."
          dark
          testid="approach-head"
        />
        <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-14 md:grid-cols-3 lg:gap-12">
          {STEPS.map((s, i) => (
            <Reveal key={s.number} delay={i * 0.12}>
              <div data-testid={s.testid} className="group relative">
                <p className="font-serif text-6xl font-light text-amber/90 transition-colors duration-500 sm:text-7xl">
                  {s.number}
                </p>
                <span className="mt-5 block h-px w-full bg-paper/15">
                  <span className="block h-px w-10 bg-amber transition-all duration-500 group-hover:w-full" />
                </span>
                <h3 className="mt-6 font-mono text-sm font-medium uppercase tracking-[0.2em] text-paper">
                  {s.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-paper/65">
                  {s.description}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
